export default function validateEmail (value, _field) {
	let valid = true;
	let msg = '';

	if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
		msg = "Invalid email address";
		valid = false;
	}
	return {valid, msg};
}